export const capabilities = [
  {
    title: "Development",
    description:
      "Our team of skilled software engineers ensures the delivery of high-performance solutions tailored to your needs.",
  },
  {
    title: "Design",
    description:
      "Let our creative minds shape the look and feel of your projects, ensuring a visually appealing and user-friendly experience.",
  },
  {
    title: "Product Management",
    description:
      "Strategic planning is key to a successful product launch. Our experts guide you through the process, ensuring a seamless journey.",
  },
  {
    title: "Project Management",
    description:
      "Efficiency is at the heart of project success. We provide oversight to meet your project goals.",
  },
];

export const whyChooseActiveTech = [
  {
    darkImgSrc: "/Images/darkBalls.png",
    lightImgSrc: "/Images/lightBalls.png",
    desc: "Our team comprises seasoned software engineers, boasting industry expertise spanning 5 to 10 years.",
    title: "Skilled Professionals",
  },
  {
    darkImgSrc: "/Images/darkBanknote.png",
    lightImgSrc: "/Images/lightBanknote.png",
    desc: "Save costs while enjoying top-notch quality. We believe in delivering value without compromise.",
    title: "Cost-Effective Solutions",
  },
  {
    darkImgSrc: "/Images/darkNotes.png",
    lightImgSrc: "/Images/lightNotes.png",
    desc: "No two projects are the same. We offer customized solutions to meet your unique requirements.",
    title: "Tailored Services",
  },
];

export const hiringMadeEasy = [
  {
    title: "Connect With Us",
    desc: "Reach out to discuss your project requirements.",
  },
  {
    title: "Discuss Required Tech Stack",
    desc: "We help you choose the right technology for your project.",
  },
  {
    title: "Select Your Team",
    desc: "We help you choose the right talent for your project.",
  },
  {
    title: "Kick-Off Your Project",
    desc: "Start your project with confidence, knowing you have a skilled team by your side.",
  },
];

export const agileProcesses = [
  {
    title: "Requirement Phase",
    desc: [
      "We start by collaboratively defining project requirements through user stories and maintaining a prioritized product backlog.",
    ],
    containerStyle: "-top-6 smLaptop:-top-10 left-1/2 -translate-x-1/2",
    iconStyle:
      "absolute top-1/2 -translate-y-1/2 smLaptop:translate-y-[10%] desktop:-translate-y-[30%] left-0",
  },
  {
    title: "Design Phase",
    desc: [
      "Our design process is incremental, aligning with the prioritized backlog.",
    ],
    containerStyle:
      "top-[25%] -translate-y-[25%] right-0 bg-base py-4 translate-x-1/2",
    iconStyle: " top-0 left-1/2 -translate-x-1/2 rotate-90",
  },
  {
    title: "Development Phase",
    desc: [
      "We employ iterative development, breaking down the project into short sprints that result in a potentially shippable product increment.",
    ],
    containerStyle:
      "bottom-[25%] translate-y-[10%] right-0 bg-base py-4 translate-x-1/2",
    iconStyle: "top-0 left-1/2 -translate-x-1/2 rotate-90",
  },
  {
    title: "Testing Phase",
    desc: [
      "Automated testing is prioritized throughout development to maintain code quality.",
    ],
    containerStyle:
      "bottom-6 smLaptop:bottom-10 translate-y-full left-1/2 -translate-x-1/2",
    iconStyle:
      "top-1/2 -translate-y-1/2 smLaptop:translate-y-[10%] desktop:-translate-y-[30%] right-0 rotate-180",
  },
  {
    title: "Deployment Phase",
    desc: [
      "We strive for continuous deployment, allowing us to release features independently and respond quickly to changing requirements.",
    ],
    containerStyle:
      "bottom-[25%] translate-y-[10%] left-0 bg-base py-4 -translate-x-1/2",
    iconStyle: "bottom-0 left-1/2 -translate-x-1/2 -rotate-90",
  },
  {
    title: "Release Phase",
    desc: [
      "Release planning is based on feature completion and user feedback.",
    ],
    containerStyle:
      "top-[25%] -translate-y-[25%] left-0 bg-base py-4 -translate-x-1/2",
    iconStyle: "bottom-0 left-1/2 -translate-x-1/2 -rotate-90",
  },
];

export const whyChooseAgile = [
  {
    title: "Adaptability",
    desc: "Agile allows us to adapt to changing requirements and priorities swiftly.",
  },
  {
    title: "Customer-Centric",
    desc: "Our process ensures frequent user feedback, resulting in solutions that align closely with customer expectations.",
  },
  {
    title: "Collaborative Approach",
    desc: "Cross-functional teams foster collaboration, creativity, and efficient problem-solving.",
  },
  {
    title: "Continuous Improvement",
    desc: "Through regular retrospectives, we actively seek ways to enhance our processes and deliver even greater value to our clients.",
  },
  {
    title: "Transparency & Visibility",
    desc: "Regular reviews, demos, and clear progress tracking give stakeholders full visibility into project status, priorities, and outcomes at every stage",
  },
  {
    title: "Predictable Delivery",
    desc: "Time-boxed sprints and clear planning help teams provide more accurate timelines, manage expectations effectively, and deliver consistently.",
  },
];
